// Meta Pixel conversion event for the Message Ori handoff actions.
//
// The pixel itself is loaded (or not) by the host-gated snippet in
// index.html; on dev/preview hosts `window.fbq` is simply absent and this
// is a no-op. Mirrors tiktok.ts: all three handoff actions (Open Messages /
// copy number / copy message) report the SAME standard `Contact` event so
// the volume stays on one Ads Manager optimization goal — the per-action
// split lives in our own /api/web-events telemetry, not in Meta.
//
// `eventID` (Meta's capitalisation, vs TikTok's `event_id`) future-proofs
// deduplication if we ever mirror the event through the Conversions API.

type Fbq = (event: string, name: string, props?: object, opts?: object) => void;

export function trackMetaContact(): void {
  const fbq = (window as unknown as { fbq?: Fbq }).fbq;
  if (typeof fbq !== 'function') return;
  try {
    fbq(
      'track',
      'Contact',
      { content_name: 'message_ori' },
      { eventID: crypto.randomUUID() },
    );
  } catch {
    /* analytics must never break the handoff UX */
  }
}
